<template>
  <div class="py-lg-6 px-lg-8 py-md-4 px-md-5 pa-4">
    <v-row>
      <v-col cols="5" class="d-flex align-center">
        <h2 class="font-weight-regular mr-2">
          {{ $t('admin["Les délais de notifications"]') }}
        </h2>
      </v-col>
      <v-col>
        <div class="d-flex justify-lg-end">
          <v-btn
            size="small"
            class="mx-2 text-caption"
            color="teal-darken-1"
            v-for="(btn, i) in btns"
            :key="i"
            @click="actionHandler(btn.type, btn.value)"
          >
            <v-icon size="18" v-if="btn.icon != ''" class="mr-1">
              {{ btn.icon }}
            </v-icon>
            {{ $t(`admin["${btn.label}"]`) }}
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row class="mt-2">
      <v-col cols="12" lg="6" md="7">
        <v-text-field
          v-model="search"
          :placeholder="$t(`admin[&quot;Rechercher une notification&quot;]`)"
          :hint="
            $t(
              `admin[&quot;Rechercher une notification à partir des mots clés&quot;]`
            )
          "
          variant="underlined"
          density="compact"
          prepend-inner-icon="mdi-magnify"
          color="teal-darken-2"
          clearable
        ></v-text-field>
      </v-col>
    </v-row>

    <v-data-table
      v-if="!loading"
      :search="search"
      :headers="headers"
      :items="items"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:[`item.frequency`]="{ item }">
        {{ $t(`admin["${item.frequency}"]`) }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon size="large" @click="editItem(item)"> mdi-eye </v-icon>
      </template>
    </v-data-table>

    <div v-else class="d-flex justify-center align-center" style="height: 40vh">
      <v-progress-circular
        :size="45"
        :width="2"
        color="grey"
        indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script src="./js/ticketNotificationList.js"></script>